import useExperiments from "@Hooks/selector/useExperiments";
import RouteType from "@Route/types/Route.type";
import ParamsType from "@SearchResults/types/params/Params.type";

export default function useFlixbusViaTravelierConnectExperiment(params: ParamsType) {
    const {flixbusViaTC} = useExperiments()
    const {
        departureStation: {
            countryId: departureCountryId = 0,
        } = {},
        destinationStation: {
            countryId: destinationCountryId = 0,
        } = {},
    } = params || {}

    // Croatia, BIH, Serbia, Montenegro
    const excludedCountryIds = [1, 2, 5, 9]

    const prepareRoutesForExperiment = (routes: RouteType[]) => {
        let filteredRoutes = routes
        const hasTConnectFlixRoutes = routes.some((route) => route.companyId === '4955')
        const hasDistribusionFlixRoutes = routes.some((route) => route.companyId === '488')
        const isExcludedCountry = excludedCountryIds.includes(departureCountryId) || excludedCountryIds.includes(destinationCountryId)
        
        // When neither station is in excluded countries, use experiment flag to decide between T-Connect and Distribusion
        if (hasTConnectFlixRoutes && !isExcludedCountry) {
            if (flixbusViaTC) {
                // Show T-Connect routes, hide Distribusion routes
                filteredRoutes = routes.map((route) => {
                    if (route.companyId === '488') {
                        return null
                    }
                    return route
                })
            } else {
                // Show Distribusion routes, hide T-Connect routes
                filteredRoutes = routes.map((route) => {
                    if (route.companyId === '4955') {
                        return null
                    }
                    return route
                })
            }
        }

        // When either station is in excluded countries (Croatia, BIH, Serbia, Montenegro),
        // always hide T-Connect routes to prefer Distribusion routes
        if (hasTConnectFlixRoutes && isExcludedCountry) {
            filteredRoutes = routes.map((route) => {
                if (route.companyId === '4955') {
                    return null
                }
                return route
            })
        }

        return filteredRoutes.filter((route) => !!route)
    }

    return {
        prepareRoutesForExperiment,
        flixbusViaTC,
    }
}